// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import CompSearchField from "components/CompSearchField";
import CompDropdown from "components/CompDropdown";
import TableBeneficiary from "components/TableBeneficiary";
import Title from "components/Title";
import * as S from "./styles";
import { useApi } from "hooks/useApis";
import { z } from "zod";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CircularProgress } from "@mui/material";
import {
  distributionPoints,
  status_options,
  type_options,
  sort_options,
} from "utils/constants";
import Typography from "@mui/material/Typography";
import ExpirationWarning from "components/ExpirationWarning";
import CompAutocomplete from "components/CompAutocomplete";
import * as palette from "styles/variables";
import { DownloadReportsButton } from "components/DownloadReportsButton";
import { Grid } from "@mui/material";

const BeneficiaryManagement = () => {
  const api = useApi();

  const [beneficiaryList, setBeneficiaryList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalBenefits, setTotalBenefits] = useState(0);

  const abortControllerRef = useRef(null);

  const createBeneficiarySearchSchema = z.object({
    // Search Information
    b_status: z.string().optional(),
    b_type: z.string().optional(),
    search: z.string().optional(),
    sort: z.string().optional(),
    city: z.string().optional(),
  });

  const methods = useForm({
    resolver: zodResolver(createBeneficiarySearchSchema),
    mode: "all",
    criteriaMode: "all",
    defaultValues: getDefaultFilters(),
  });

  const b_status_value = methods.watch("b_status");
  const b_type_value = methods.watch("b_type");
  const search_value = methods.watch("search");
  const sort_value = methods.watch("sort");
  const city_value = methods.watch("city");

  const benefitFilters = {
    b_status: b_status_value,
    b_type: b_type_value,
    search: search_value,
    city: city_value,
  };

  useEffect(() => {
    methods.handleSubmit(onSubmit, onError)();
  }, [currentPage]);

  useEffect(() => {
    if (currentPage === 1) {
      methods.handleSubmit(onSubmit, onError)();
    } else {
      setCurrentPage(1);
    }
  }, [b_status_value, b_type_value, sort_value, city_value]);

  async function onSubmit(data) {
    try {
      setLoading(true);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const controller = new AbortController();
      abortControllerRef.current = controller;
      const filteredList = await api.listBeneficiary(
        data.b_status,
        data.b_type,
        data.search,
        data.sort,
        data.city,
        currentPage,
        false,
        { signal: controller.signal }
      );
      if (filteredList.code === "ERR_CANCELED") {
        return;
      }

      // setChangePage(currentPage);
      setBeneficiaryList(filteredList?.results);
      setTotalPages(filteredList?.total_pages);

      sessionStorage.setItem(
        "cria-web@beneficiaryFilters",
        JSON.stringify(data)
      );
      setTotalBenefits(filteredList?.count);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  function onError(errors) {
    console.log("Failed to submit:", errors);
  }

  return (
    <S.PageContainer>
      <Title
        titleText="Gerência de beneficiário"
        subtitleTexts={["Início", " Gerência de beneficiário"]}
      />
      <S.PageContent>
        <S.MainContainer>
          <FormProvider {...methods}>
            <S.Form onSubmit={methods.handleSubmit((data) => onSubmit(data, 1), onError)}>
              <Grid container spacing={2}>
                {/* Linha 1 */}
                <Grid item xs={12} md={6}>
                  <S.DateFieldsContainer>
                    <S.DateFieldsTitle>BUSCA DE BENEFICIÁRIO</S.DateFieldsTitle>
                    <CompSearchField
                      placeholder="Digite o nome ou NIS ou CPF para buscar"
                      name="search"
                      register={methods.register}
                      unregister={methods.unregister}
                    />
                  </S.DateFieldsContainer>
                </Grid>
                <Grid item xs={12} md={6}>
                  <CompDropdown
                    defaultValue="0"
                    textLabel="TIPO DE BENEFÍCIO:"
                    options={type_options}
                    name={"b_type"}
                    register={methods.register}
                    unregister={methods.unregister}
                    id="test"
                  />
                </Grid>
  
                {/* Linha 2 */}
                <Grid item xs={12} md={6}>
                  <CompDropdown
                    defaultValue=""
                    textLabel="STATUS DO BENEFÍCIARIO"
                    options={status_options}
                    name={"b_status"}
                    register={methods.register}
                    unregister={methods.unregister}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CompAutocomplete
                    defaultValue=""
                    textLabel="MUNICÍPIO:"
                    options={distributionPoints}
                    name={"city"}
                    placeholder="Selecione um município"
                    register={methods.register}
                    unregister={methods.unregister}
                  />
                </Grid>
              </Grid>
  
              <S.CabecalhoTabela>
                <div>
                  <Typography variant="h6">Lista de beneficiários</Typography>
                  <p style={{ fontWeight: "normal" }}>
                    {totalBenefits?.toLocaleString("pt-BR")} benefícios
                  </p>
                </div>
                <CompDropdown
                  defaultValue="0"
                  options={sort_options}
                  name={"sort"}
                  register={methods.register}
                  unregister={methods.unregister}
                />
              </S.CabecalhoTabela>
            </S.Form>
          </FormProvider>
          {loading ? (
            <S.LoadingBoxContainer>
              <CircularProgress style={{ color: `${palette.lightAmarelo}` }} />
            </S.LoadingBoxContainer>
          ) : (
            // "Carregando..."
            // <LoadingBox>
            <TableBeneficiary
              beneficiaryList={beneficiaryList}
              page={currentPage}
              totalPages={totalPages}
              setPage={setCurrentPage}
            />
          )}
          <DownloadReportsButton benefitFilters={benefitFilters} />
          <ExpirationWarning />
        </S.MainContainer>
      </S.PageContent>
    </S.PageContainer>
  );
  
};

function getDefaultFilters() {
  return (
    JSON.parse(sessionStorage.getItem("cria-web@beneficiaryFilters")) ||
    undefined
  );
}

export default BeneficiaryManagement;
